<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :appendToBody="true"
  >
    <div slot="content">
      <el-form
        label-width="120px"
        ref="form"
        :rules="editFormRules"
        :model="dataForm"
      >
        <el-form-item label="标题：" prop="Title">
          <el-input
            placeholder="标题"
            v-model="dataForm.Title"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="支出描述：" prop="Describe">
          <el-input
            placeholder="支出描述"
            v-model="dataForm.Describe"
            clearable
            maxlength="100"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="支出金额：" prop="Amount">
          <el-input
            placeholder="支出金额"
            v-model="dataForm.Amount"
            clearable
            maxlength="100"
            style="width:220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="支出时间:" prop="ExpendTime">
          <el-date-picker
            v-model="dataForm.ExpendTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="附件:" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    ImplementId: {
      type: String,
      default: "",
    },
  },
  components: {
    OfDialog,
  },
  data() {
    return {
      editFormRules: {
        Title: { required: true, message: "标题不能为空", trigger: "blur" },
        Describe: {
          required: true,
          message: "支出描述不能为空",
          trigger: "blur",
        },
        ExpendTime: {
          required: true,
          message: "支出时间不能为空",
          trigger: "blur",
        },
        Amount: {
          required: true,
          message: "支出金额不能为空",
          trigger: "blur",
        },
      },
      formTitle: "项目支出", //标题
      dataForm: {},
      fileList: [], //附件数组
      isConfirm: false,
    };
  },
  mounted() {},
  methods: {
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.ImplementId = that.ImplementId;
          params.ExpendTime = params.ExpendTime / 1000;
          api
            .AddProjectExpend(params)
            .then((res) => {
              that.isConfirm = false;
              if (res.data.Code === 0) {
                that.$message({
                  message: "提交成功",
                  type: "success",
                });
                that.$emit("formCallBack", params);
              } else {
                that.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              that.isConfirm = false;
              that.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    cancel() {
      this.$emit("formCallBack", null);
    },
    //上传成功
    handleSuccess(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.File && !that.dataForm.File) {
          that.dataForm.File = rtnResult.Data.FileId;
        } else {
          that.dataForm.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //删除
    handleRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      fileList.forEach((item) => {
        if (that.dataForm.File == "") {
          that.dataForm.File = item.response.Data.FileId;
        } else {
          that.dataForm.File += "," + item.response.Data.FileId;
        }
      });
    },
  },
};
</script>
<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
</style>